import { useHistory } from 'react-router-dom';

const useCustomRouter = () => {
  const history = useHistory();

  const goTo = (path: string, fn: string = 'push') => () => {
    history[fn](path);
  };

  return { ...history, goTo };
};

export default useCustomRouter;
